import { render } from "./mumbai.vue?vue&type=template&id=2e4c8eca&scoped=true"
import script from "./mumbai.vue?vue&type=script&lang=js"
export * from "./mumbai.vue?vue&type=script&lang=js"

import "./mumbai.vue?vue&type=style&index=0&id=2e4c8eca&scoped=true&lang=css"

import exportComponent from "/harness/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4c8eca"]])

export default __exports__